import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer bg-black small text-center text-light" }
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-light text-opacity-75" }, " copyright © ironwood whistles 2023 ", -1)
const _hoisted_4 = { class: "container col-12 col-lg-4 col-md-6" }
const _hoisted_5 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterLinkComponent = _resolveComponent("FooterLinkComponent")!
  const _component_ImpressumComponent = _resolveComponent("ImpressumComponent")!
  const _component_AgbComponent = _resolveComponent("AgbComponent")!
  const _component_DsgvoComponent = _resolveComponent("DsgvoComponent")!
  const _component_CitesComponent = _resolveComponent("CitesComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FooterLinkComponent, {
              "link-text": "impressum",
              target: "#impressumModal",
              "col-size": "12"
            }),
            _createVNode(_component_FooterLinkComponent, {
              "link-text": "dsgvo",
              target: "#dsgvoModal",
              "col-size": "12"
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_ImpressumComponent),
    _createVNode(_component_AgbComponent),
    _createVNode(_component_DsgvoComponent),
    _createVNode(_component_CitesComponent)
  ], 64))
}